{
  "railOverview": "Tổng quan",
  "railPatients": "Bệnh nhân",
  "railAppointments": "Lịch hẹn",
  "railLeads": "Lead",
  "railMarketing": "Chính sách bán hàng",
  "railMessaging": "Hộp thoại đa kênh",
  "railInternalChat": "Nhắn tin",
  "railFinance": "Thu – Chi",
  "railWarehouse": "Kho",
  "railCatalog": "Danh mục",
  "railWork": "Công việc",
  "railHr": "Nhân sự",
  "railReports": "Báo cáo",
  "railSettings": "Cài đặt",
  "railNav": "Điều hướng chính",
  "workspaceDefault": "Mặc định",
  "workspaceSwitch": "Chọn workspace",
  "workspaceAdd": "Thêm workspace",
  "workspaceCustomize": "Tùy chỉnh sidebar",
  "workspaceHome": "Trang mở đầu",
  "workspaceHomeTitle": "Tùy chỉnh workspace",
  "workspaceName": "Tên workspace",
  "workspaceNamePlaceholder": "Ví dụ: Lễ tân",
  "workspaceRails": "Mục trên sidebar",
  "workspaceDelete": "Xóa workspace",
  "workspaceSaved": "Đã lưu workspace",
  "workspaceSaveFailed": "Không lưu được workspace",
  "organizations": "Tổ chức",
  "provisionClinic": "Tạo tổ chức mới",
  "dashboard": "Tổng quan",
  "patients": "Bệnh nhân",
  "leads": "Lead",
  "messaging": "Hộp thoại đa kênh",
  "internalChat": "Nhắn tin",
  "messagingCanned": "Quản lý câu trả lời nhanh",
  "appointments": "Lịch hẹn",
  "catalog": "Danh mục",
  "treatmentCatalog": "Danh mục điều trị",
  "treatmentCategories": "Nhóm dịch vụ",
  "treatmentUoms": "Đơn vị tính dịch vụ",
  "treatmentJournals": "Nhật ký điều trị",
  "drugs": "Danh mục thuốc",
  "prescriptionTemplates": "Mẫu đơn thuốc",
  "incomeCategories": "Danh mục thu",
  "expenseCategories": "Danh mục chi",
  "paymentMethods": "Hình thức thanh toán",
  "commissionRules": "Quy tắc hoa hồng",
  "appointmentTypes": "Loại lịch hẹn",
  "customerSources": "Nguồn khách hàng",
  "diagnosisCodes": "Chẩn đoán",
  "itemCatalog": "Danh mục hàng",
  "warehouseConfig": "Cấu hình kho",
  "treatments": "Điều trị",
  "treatmentPlans": "Kế hoạch điều trị",
  "treatmentSessions": "Nhật ký điều trị",
  "finance": "Thu – Chi",
  "payments": "Thanh toán",
  "incomes": "Phiếu thu",
  "expenses": "Phiếu chi",
  "cashbook": "Sổ quỹ",
  "promotions": "Khuyến mãi",
  "commissions": "Hoa hồng",
  "payroll": "Lương",
  "payrollFormulas": "Công thức lương",
  "payrollComponents": "Khoản lương",
  "payrollMine": "Phiếu lương của tôi",
  "payrollAdvances": "Tạm ứng lương",
  "warehouse": "Kho",
  "stockIn": "Nhập kho",
  "stockOut": "Xuất kho",
  "transfers": "Chuyển kho",
  "stocktakes": "Kiểm kho",
  "reports": "Báo cáo",
  "reportOverview": "Tổng quan",
  "reportRevenue": "Doanh thu",
  "reportPatients": "Bệnh nhân",
  "referrers": "Người giới thiệu",
  "referralCommissions": "Hoa hồng người giới thiệu",
  "reportReferrers": "Người giới thiệu",
  "reportAppointments": "Lịch hẹn",
  "reportTreatments": "Kế hoạch điều trị",
  "leadReports": "Lead",
  "inventoryReports": "Báo cáo kho",
  "labo": "Labo",
  "labOrders": "Đơn lab",
  "labPartners": "Đối tác xưởng",
  "suppliers": "Nhà cung cấp",
  "labCatalog": "Loại phục hình, vật liệu & màu lab",
  "prescriptions": "Đơn thuốc",
  "clinics": "Phòng khám",
  "staff": "Nhân viên",
  "departments": "Phòng ban",
  "attendance": "Chấm công",
  "attendanceClock": "Chấm công",
  "attendanceHistory": "Chấm công",
  "attendanceRequests": "Yêu cầu điều chỉnh chấm công",
  "overtime": "Tăng ca",
  "overtimeRequests": "Đơn tăng ca",
  "overtimeTypes": "Loại tăng ca",
  "workTimesheet": "Nhật ký điều trị",
  "tasks": "Quản lý công việc",
  "projects": "Quản lý dự án",
  "kpiSheets": "KPI",
  "kpiMetrics": "Chỉ tiêu KPI",
  "myKpi": "KPI của tôi",
  "scheduling": "Lịch làm việc",
  "teamSchedule": "Lịch làm việc",
  "timeOff": "Nghỉ phép",
  "shiftTypes": "Loại ca",
  "timeOffTypes": "Loại phép",
  "leaveEntitlements": "Hạn mức phép",
  "leaveLedger": "Sổ phép",
  "leaveReport": "Báo cáo phép",
  "weeklyTemplates": "Mẫu lịch",
  "assignments": "Gán lịch",
  "users": "Người dùng",
  "permissionGroups": "Vai trò",
  "auditLog": "Nhật ký hệ thống",
  "automation": "Automation",
  "outbound": "Gửi tin",
  "settings": "Cài đặt"
}
